module.exports = __webpack_public_path__ + "static/media/hp_08.91ad30bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/JPEG/hp_08.jpg
// module id = 5819
// module chunks = 0